import React from "react";
import { AiOutlineSearch } from "react-icons/ai";

function Omnisearch({ onSearch }) {
  return (
    <div className="relative w-full">
      <input
        type="text"
        placeholder="Search files..."
        onChange={(e) => onSearch(e.target.value)}
        className="w-full py-2.5 pl-4 pr-10 text-sm rounded-xl border border-slate-200 bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-[#52aeb4] focus:border-[#52aeb4] transition-all"
      />
      <AiOutlineSearch className="absolute right-3 top-2.5 text-gray-400 text-lg" />
    </div>
  );
}

export default Omnisearch;
